import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FiDownload } from 'react-icons/fi';

import { Container, Name, RankNumber, Stat, Thumb } from './styles';

const propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    downloadsCount: PropTypes.number,
    images: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  rank: PropTypes.number.isRequired,
};

const RankCard = ({ project, rank }) => {
  const history = useHistory();
  const { id, name, downloadsCount, images } = project;

  function goToProject() {
    history.push(`/projects/${id}`);
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      goToProject();
    }
  }

  return (
    <Container
      role="link"
      tabIndex={0}
      aria-label={`#${rank} ${name}`}
      onClick={goToProject}
      onKeyDown={handleKeyDown}
    >
      <Thumb>
        {images && images.length > 0 && (
          <img src={images[0].url} alt="" loading="lazy" />
        )}
        <RankNumber>#{rank}</RankNumber>
      </Thumb>
      <Name>{name}</Name>
      <Stat>
        <FiDownload size={13} />
        {(downloadsCount || 0).toLocaleString('pt-BR')} downloads
      </Stat>
    </Container>
  );
};

RankCard.propTypes = propTypes;

export default RankCard;
